/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorCommand } from '../../models/create-vendor-command';
import { CreateVendorCommandResult } from '../../models/create-vendor-command-result';

export interface ApiVendorsCreateVendorPost$Plain$Params {
  
    /**
     * The command containing the details for the new Vendor.
     */
    body?: CreateVendorCommand
}

export function apiVendorsCreateVendorPost$Plain(http: HttpClient, rootUrl: string, params?: ApiVendorsCreateVendorPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateVendorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsCreateVendorPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateVendorCommandResult>;
    })
  );
}

apiVendorsCreateVendorPost$Plain.PATH = '/api/Vendors/CreateVendor';
